import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject, Input,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

interface PlanningDraftRoutesSortingDialogModel {
  sortBy: string;
  sortByType: string;
}

require('./planning-draft-routes-sorting-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-routes-sorting-dialog',
  templateUrl: './planning-draft-routes-sorting-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftRoutesSortingDialogComponent implements OnInit {

  @Output() onSortTypeChange = new EventEmitter<{sortBy: string, sortByType: string}>();

  public sortByType: string;
  public sortBy: string;

  constructor(@Inject(PANEL_DATA) public data: PlanningDraftRoutesSortingDialogModel) {
  }

  ngOnInit() {
    this.sortBy = this.data.sortBy;
    this.sortByType = this.data.sortByType;
  }

  onToggleSortTypeChange(sortBy: string, sortByType) {
    this.sortBy = sortBy;
    this.sortByType = sortByType;
    this.onSortTypeChange.emit({sortBy: sortBy, sortByType: sortByType});
  }

}
